import { createTranslocoScope } from '@gde-mit/angular-core';

export const DOCUMENT_LIBRARY_TRANSLOCO = createTranslocoScope(
  'DOCUMENT_LIBRARY',
  (lang) => import(`./i18n/${lang}.json`),
);

export const DOCUMENT_LIBRARY_I18N_PREFIX = 'DOCUMENT_LIBRARY';
